import axios from 'axios'
import ApiConnector from '../apiConnector';

const bd = new ApiConnector(axios);

const actions = {
    async get({commit}, params) {
      try {
        const res = await bd.get(params);
        if(params.option === 'menu'){
          commit('setMenuItems',res)
          return
        }
        commit('setTableItems', res)
        // console.log(res)
      } catch (error) {
         console.log(error) 
      }
    },
    changeOption({commit}, option) {
      // console.log('option: ',option);
      commit('setOptionSelect',option)
    },
    changePage({commit},page) {
      // console.log(page)
      commit('setCurrentPage', page);
    },
    changeDevice({commit}) {
      let device = null
      navigator.userAgent.includes('Mobile') 
      ? device = true 
      : device = false
      commit('setMobile',device)
    },
    async getItem({state},item) {
      const res = await bd.get(item);
      return res.data[0];
      // console.log(params)
      // const item = state.tableItems.data.filter( e => e.id === id );
      // console.log(state.tableItems.data)
      // console.log(item[0])
    },
    async removeItem({commit},item){
      try {
        const res = await bd.get(item);
        // console.log(res)
        return res
      } catch (error) {
        console.log(error)
      }
    },
    activePopup({commit}) {
      commit('setShowPopup');
    },
    changeForm({commit},form){
      commit('setActiveForm',form)
    },
    changeActiveEl({commit},element) {
      commit('setActiveEl',element);
    }
  };

  export default actions;